import type { ReactNode } from 'react';
import { useLayoutEffect, useState } from 'react';
import MobileDetect from 'mobile-detect';

type MatchDevicesProps = {
  list: string[];
  editingMode?: boolean;
  children?: ReactNode;
};
export function MatchDevices({
  list,
  editingMode = false,
  children = null
}: MatchDevicesProps) {
  const [currentDevice, setCurrentDevice] = useState<
    'mobile' | 'tablet' | 'desktop' | null
  >(null);

  useLayoutEffect(() => {
    const detector = new MobileDetect(window.navigator.userAgent);

    if (detector.tablet()) {
      setCurrentDevice('tablet');
    } else if (detector.mobile()) {
      setCurrentDevice('mobile');
    } else {
      setCurrentDevice('desktop');
    }
  }, []);

  if ((!currentDevice || !list.includes(currentDevice)) && !editingMode) {
    return null;
  }

  return children;
}
